import React from "react";
import DAAModuleSubtopic from "../DAAModuleSubtopic";

const DAA_SumOfSubsets = () => (
  <DAAModuleSubtopic
    title="Sum of Subsets Problem - Backtracking"
    videos={[
      "https://www.youtube.com/embed/kyLxTdsT8ws",
      "https://www.youtube.com/embed/a3Wuqq53QyM",
      "https://www.youtube.com/embed/rbZaA-DL4do",
    ]}
    takeaways={[
      { text: "Significance of Bounding Function in Subset Sum." },
      { text: "A bounding function is used to prune unnecessary branches in the state space tree." },
      { text: "Reduces the number of recursive calls, making the algorithm more efficient than pure backtracking." },
      { text: "Significantly reduces search space, improving efficiency." },
      { text: "State space tree with bounding has fewer recursive calls, leading to better performance." },
      { text: "Complexity Analysis: Without bounding: O(2ⁿ), With bounding: Much faster in practical cases due to pruning." },
    ]}
    questions={[
      {
        text: "Given the set of positive numbers {7,11,13,24}, find if there is a subset for a given sum m=31 using backtracking technique. Discuss the significance of bounding function in the context of the above subset sum problem through the full state space tree and highlight the recursive calls on the tree.",
      },
      {
        text: "Define the subset sum problem. Solve it for the set {40, 30, 50, 10, 20} with a target sum of 60 using the backtracking approach.",
      },
    ]}
    exampleVideos={[
      "https://www.youtube.com/embed/rLUc6NV4RWk",
      "https://www.youtube.com/embed/delsnw7W2DE",
      "https://www.youtube.com/embed/FN5QxDEaiwM",
    ]}
  />
);

export default DAA_SumOfSubsets ;
